<template>
  <div class="solutions">
    <!-- 顶部标题区域-->
    <section class="products-header solutions-header">
      <div class="container">
        <h1 class="page-title">
          <span class="title-glow">网络安全</span>
        </h1>
        <p class="page-subtitle">安全服务 · 合规服务 · 运营服务</p>
      </div>
    </section>

    <!-- 内容区域 -->
    <section class="content-section">
      <div class="container">
        <div v-if="loading" class="loading-container">
          <p>加载中...</p>
        </div>
        <div v-else-if="error" class="error-container">
          <p>{{ error }}</p>
        </div>
        <div v-else class="tab-panel">
          <div class="cases-grid">
            <div
              v-for="(caseItem, index) in cases"
              :key="index"
              class="case-card animate-fade-in-up"
              @click="goToDetail(caseItem)"
            >
              <div class="case-image">
                <img
                  :src="resolveSolutionImage(caseItem.image)"
                  :alt="caseItem.title"
                  class="case-img"
                />
              </div>
              <div class="case-content">
                <h3>{{ caseItem.title }}</h3>
                <p class="case-description">{{ caseItem.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

// 使用 require.context 让 webpack 在打包时收集网络安全列表图片资源
const securityImageCtx = require.context('@/assets/security/img_home', false, /\.(png|jpe?g)$/)

export default {
  name: 'SecuritySolutions',
  data() {
    return {
      cases: [],
      loading: false,
      error: null
    }
  },
  async mounted() {
    await this.fetchSolutions()
    // 添加动画效果
    this.$nextTick(() => {
      const cards = document.querySelectorAll('.animate-fade-in-up')
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
          }
        })
      }, { threshold: 0.1 })
      cards.forEach((card) => observer.observe(card))
    })
  },
  methods: {
    async fetchSolutions() {
      try {
        this.loading = true
        this.error = null
        const response = await axios.get('/api/security/solutions')
        if (response.data.code === 200) {
          this.cases = Array.isArray(response.data.data) ? response.data.data : []
        } else {
          this.error = response.data.message || '获取网络安全数据失败'
          this.cases = []
        }
      } catch (error) {
        console.error('获取网络安全数据失败:', error)
        this.error = '网络请求失败，请检查服务器是否运行'
        this.cases = []
      } finally {
        this.loading = false
      }
    },
    goToDetail(item) {
      if (item && item.id) {
        this.$router.push({
          path: '/security/detail',
          query: {
            id: item.id
          }
        })
      } else {
        console.warn('网络安全项缺少ID，无法跳转到详情页', item)
      }
    },
    resolveSolutionImage(imagePath) {
      if (!imagePath) return ''
      // JSON 中配置的是 "@security_img_home/filename" 或 "@img_home/filename"
      if (imagePath.startsWith('@security_img_home/')) {
        const fileName = imagePath.replace('@security_img_home/', '')
        try {
          return securityImageCtx('./' + fileName)
        } catch (e) {
          console.warn('网络安全列表图片未找到:', fileName, e)
          return ''
        }
      }
      if (imagePath.startsWith('@img_home/')) {
        const fileName = imagePath.replace('@img_home/', '')
        try {
          return securityImageCtx('./' + fileName)
        } catch (e) {
          console.warn('网络安全列表图片未找到:', fileName, e)
          return ''
        }
      }
      // 其他情况直接返回原路径（例如外部 URL）
      return imagePath
    }
  }
}
</script>

<style scoped>
.solutions {
  /* min-height: 100vh; */
  background: #ffffff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0px;
}

.products-header {
  position: relative;
  background-image:
    url('../../assets/background_header/网络安全.png');
    /* linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0f1419 100%); */
  background-size: cover, 100%;
  background-position: center, center;
  background-blend-mode: overlay;
  padding: 45px 0;
  overflow: hidden;
  min-height: 200px;
  display: flex;
  align-items: center;
}

.products-header .container {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0;
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
}

.page-title {
  margin: 0;
  position: relative;
  z-index: 2;
  text-align: left;
  padding: 0;
}

.title-glow {
  display: inline-block;
  font-size: 46px;
  font-weight: 900;
  font-family: 'Arial Black', 'Microsoft YaHei', sans-serif;
  letter-spacing: 5px;
  color: #ffffff;
  filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.6));
  position: relative;
  backdrop-filter: blur(5px);
}

.page-subtitle {
  margin: 8px 0 0 0;
  text-align: left;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  line-height: 1.8;
  opacity: 1;
  max-width: 900px;
  margin-left: 2em;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(5px);
}

.content-section {
  background: #f6f8fb;
  padding: 40px 0;
}

.tab-panel {
  background: #ffffff;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(15, 29, 64, 0.08);
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
}

.case-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
}

.case-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.case-image {
  height: 180px;
  overflow: hidden;
}

.case-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.case-content {
  padding: 30px;
}

.case-content h3 {
  margin: 0 0 15px;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

.case-description {
  color: #666;
  line-height: 1.6;
  margin: 0;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.animate-fade-in-up {
  opacity: 0;
  transform: translateY(30px);
  will-change: transform, opacity;
}

.animate-fade-in-up.is-visible {
  animation: fade-in-up 0.8s ease-out forwards;
}

@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes gradient-shift {
  0%,
  100% {
    background-position: 0% center;
  }
  50% {
    background-position: 100% center;
  }
}

.loading-container,
.error-container {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.error-container {
  color: #e74c3c;
}

@media (max-width: 768px) {
  .products-header {
    padding: 80px 0 60px;
  }

  .title-glow {
    font-size: 42px;
  }

  .tab-panel {
    padding: 24px;
  }

  .cases-grid {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: 20px;
  }
}
</style>

